<template>
  <div class="SectionContact">
    <UIContainer class="SectionContact__container">
      <template #left>
        <img src="./assets/contact/bg.avif" class="SectionContact__image" alt="Contact" />
      </template>

      <template #right>
        <div class="SectionContact__content">
          <SectionTitle :title="title" />

          <p class="SectionContact__description">
            We’d love to chat and see how we could help! Use the form below to
            schedule a call or just email us at
            <a href="mailto:info@sustainalyse.com">info@sustainalyse.com</a> .
          </p>

          <FormContact class="SectionContact__form" />
        </div>
      </template>
    </UIContainer>
  </div>
  
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    /** Title text displayed at the top of the section */
    title?: string
  }>(),
  {
    title: '',
  },
)

import FormContact from '@/views/components/forms/FormContact.vue'
import SectionTitle from '@/views/components/misc/SectionTitle.vue'
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
</script>

<style lang="scss" scoped>
.SectionContact {
  .SectionContact__container {
    :deep(.UIContainer__grid) {
      grid-template-columns: 1fr;

      @include lg {
        grid-template-columns: 1fr 1fr;
      }
    }
  }

  .SectionContact__content {
    @include lg {
      padding-left: 4rem;
    }
  }

  .SectionContact__image {
    display: none;

    @include lg {
      display: block;
      width: 100%;
      max-width: 583px;
    }
  }

  .SectionContact__description {
    @include font-size-18px;
    margin-top: 20px;
    color: $color-ui-gray-cool-600;
    font-weight: 400;

    a {
      color: $color-ui-gray-cool-600;
    }
  }

  .SectionContact__form {
    margin-top: 2rem;
  }
}
</style>


